module.exports = __webpack_public_path__ + "static/media/dashboard.7d3e7db4.svg";